<template>
  <div class="empty">
    <div class="img" :class="{'yjs': platform=='yjs'}"></div>
    <p class="text">暂无更多符合您意向的在招岗位，推荐您去其他专场看看～</p>
    <div class="guides">
      <a href="javascript:void(0)" v-for="(item, index) in linkGuide[platform]" :key="index" @click="guide(item)"><span>{{ item.title }}</span></a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "EmptyJobStatus",
  data() {
    return {
      platform: this.$store.getters.platform.indexOf('yjs') != -1 ? 'yjs' : '51job',
      linkGuide: {
        '51job': [{
          title: '周末双休',
          id: '1892815538937450497'
        }, {
          title: '神仙外企',
          id: '1879732804507123714'
        }, {
          title: '国企热招',
          id: '1889246460604710914'
        }],
        'yjs': [{
          title: '制造业行业',
          id: '1863409449102405634'
        }, {
          title: '互联网行业',
          id: '1866718171885985794'
        }, {
          title: '能源汽车行业',
          id: '1887399129646419970'
        }]
      }
    }
  },
  computed: {
    ...mapState(["commonStore"]),
    functionCode() {
      return this.commonStore.intention.expectFunction || '';
    },
    areaCode() {
      return this.commonStore.intention.expectArea || '';
    },
  },
  created() {
    this.$nextTick(() => {
      this.$sensors.track('WidgetShow', {
        $element_id: 'sensor_bcop_nopositionguide',
        workIntegrityFunc: this.functionCode,
        workArea: this.areaCode
      })
    })
    
  },
  methods: {
    guide(item) {
      this.$sensors.track('$WebClick', {
        $element_id: 'sensor_bcop_nopositionguide',
        workIntegrityFunc: this.functionCode,
        workArea: this.areaCode,
        contentName: item.title
      });

      let url = this.platform === '51job' ? 'https://activity.51job.com/op/' : 'https://activity.yingjiesheng.com/op/';
      url += item.id;

      window.location.href = url;
    }
  }
}
</script>

<style lang="less" scoped>
.empty {
  margin: 0 8px;
  padding: 16px 0 24px;
  background-color: #FFF;
  border-radius: 16px;
}

.img {
  width: 180px;
  height: 100px;
  margin: 0 auto;
  background: url(~@/assets/img/activity/empty_job_51.png) center center no-repeat;
  background-size: 100% 100%;

  &.yjs {
    background-image: url(~@/assets/img/activity/empty_job_yjs.png);
  }
}

.text {
  font-size: 14px;
  color: #222;
  text-align: center;
  padding: 12px 46px 16px;
}

.guides {
  text-align: center;

  a {
    display: inline-block;
    width: 100px;
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: #FFF;
    text-align: center;
    margin: 0 5px;
    border-radius: 17px;
    background: linear-gradient(180deg, #FFBD65 0%, #FF6332 95%), #F96440;

    span {
      padding-right: 10px;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAgCAYAAAAbifjMAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACESURBVEiJY2AYBdQF////d/j//38CuZoT/iOAATkGGCAZ8J5cQxLQDFEgx5ACJEPuk2tIw/A15Pz///8FyDGkH8mQ+SQbADVkPraExkSWaQwMHyixfT+pmskPRIqicUA1J1BLM2llwn9IcUayZuSEhOzUQEZGxgtE247migSSNY4CygAAiVxMY5+HzkEAAAAASUVORK5CYII=) right center no-repeat;
      background-size: 8px 16px;
    }
  }
}

.adapt_pc_widescreen {
  .empty {
    width: 32rem;
    margin : 0 auto;
    padding: 24px 0 42px;
  }

  .img {
    width: 288px;
    height: 160px;
  }

  .text {
    font-size: 20px;
    padding: 16px 0 20px;
  }

  a {
    width: 140px;
    height: 48px;
    line-height: 48px;
    font-size: 18px;
    margin: 0 12px;
    border-radius: 24px;

    span {
      padding-right: 14px;
      background-size: 11px 22px;
    }
  }
}
</style>